import { useEffect, useRef } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { registerHotkey, unregisterHotkey, type HotkeyDefinition, type HotkeyHandler } from "./hotkey-registry";
type UseRegisterHotkeyOptions = HotkeyDefinition & {
  handler: HotkeyHandler;
  /** Match event.key instead of event.code for shifted characters such as "?". */
  useKey?: boolean;
  /** Also handle the shortcut while focus is in a form control or content-editable element. */
  enableOnEditable?: boolean;
  /** Consume repeated keydowns without invoking the handler again. */
  ignoreRepeat?: boolean;
};
export function useRegisterHotkey({
  id,
  keys,
  display,
  description,
  group,
  handler,
  useKey = false,
  enableOnEditable = false,
  ignoreRepeat = false
}: UseRegisterHotkeyOptions): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  useHotkeys(keys, event => {
    if (ignoreRepeat && event.repeat) return;
    return handlerRef.current();
  }, {
    preventDefault: true,
    useKey,
    enableOnFormTags: enableOnEditable,
    enableOnContentEditable: enableOnEditable
  });
  useEffect(() => {
    registerHotkey({
      id,
      keys,
      display,
      description,
      group
    }, () => handlerRef.current());
    return () => unregisterHotkey(id);
  }, [description, display, group, id, keys]);
}